import { render } from "./CheckBox.vue?vue&type=template&id=72d22b2e&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=72d22b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d22b2e"]])

export default __exports__